export const SITE_URL = "https://spoedlekkage.nl";

export const PAGES = {
  home: {
    path: "/",
    template: "home",
    title: "Spoed lekkage? 24/7 lekkageservice | Spoedlekkage.nl",
    description:
      "Spoed lekkage in Amsterdam, Noord-Holland, Utrecht of Almere? 24/7 bereikbaar. Bel of app, stuur een foto en een vakman denkt met u mee.",
    index: true,
  },
  werkgebied: {
    path: "/werkgebied",
    template: "werkgebied",
    title: "Werkgebied: Noord-Holland, Utrecht en Almere | Spoedlekkage.nl",
    description: "Wij zijn 24/7 bereikbaar in Amsterdam, Noord-Holland, Utrecht, Almere en omgeving. Bekijk alle steden waar wij lekkages verhelpen.",
    index: true,
  },
  bedankt: {
    path: "/bedankt",
    template: "thankyou",
    title: "Bericht ontvangen — Spoedlekkage.nl",
    description: "Uw bericht is ontvangen. Wij nemen zo snel mogelijk contact met u op.",
    index: false,
  },
  privacy: {
    path: "/privacyverklaring",
    template: "privacy",
    title: "Privacyverklaring | Spoedlekkage.nl",
    description: "Hoe Spoedlekkage.nl omgaat met uw gegevens: cookies, metingen, contact via telefoon en WhatsApp, en uw rechten.",
    index: true,
  },
  algemeneVoorwaarden: {
    path: "/algemene-voorwaarden",
    template: "terms",
    title: "Algemene voorwaarden | Spoedlekkage.nl",
    description: "De algemene voorwaarden van Knap Groep B.V. (handelsnaam Spoedlekkage.nl), vastgesteld op 26-10-2026.",
    index: false,
  },
  notfound: {
    path: "/404",
    template: "404",
    title: "Pagina niet gevonden | Spoedlekkage.nl",
    description: "Deze pagina bestaat niet. Bel of app ons bij een lekkage.",
    index: false,
  },
};
